import { render, staticRenderFns } from "./_match.vue?vue&type=template&id=4c712a36&scoped=true&lang=pug&"
import script from "./_match.vue?vue&type=script&lang=js&"
export * from "./_match.vue?vue&type=script&lang=js&"
import style0 from "./_match.vue?vue&type=style&index=0&id=4c712a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c712a36",
  null
  
)

export default component.exports